import { vanillaRenderers } from '@jsonforms/vanilla-renderers';
import * as controlRenderers from './control-renderers';
import * as layoutRenderers from './layout-renderers';

export const defaultRenderers = [
  ...vanillaRenderers,
  ...Object.values(controlRenderers),
  ...Object.values(layoutRenderers),
];
